import { render, staticRenderFns } from "./CathayFamily.vue?vue&type=template&id=14ab70e1"
import script from "./CathayFamily.vue?vue&type=script&lang=js"
export * from "./CathayFamily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports